import { IPartner } from "Dashboard/scenes/Partners/domain";
import CancelIcon from "@mui/icons-material/Cancel";
import { grey } from "@mui/material/colors";
import { useAppDispatch } from "hooks/hooks";
import {
  selectState,
  setIncidentPopover,
  setIndexForDeletion,
  setSelectedIndex,
} from "../main.slice";
import { useSelector } from "react-redux";
import { FormatDate } from "utils/dateUtils";
import { FormatMoneyNumber } from "utils/numberUtils";
import { FaInfoCircle, FaMusic } from "react-icons/fa";
import { TfiInfoAlt } from "react-icons/tfi";
import InfoTooltip from "components/Popup/InfoTooltip";
import { setAdditionalInfoPopover } from "../../AccountReceivable/accountReceivable.slice";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasFullAccessTo } from "utils/authUtil";

interface IProps {
  index: number;
  item: IPartner;
};

const TableRow = ({ item, index }: IProps) => {
  const dispatch = useAppDispatch();
  const { selectedIndex } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);

  return (
    <div
      key={index}
      className={`row ${selectedIndex === index ? "active" : ""}`}
      onClick={() => dispatch(setSelectedIndex(index))}
    >
      <div className="col center">
        {item.hasUnacknowledgedAdditionalItems && (
          <FaInfoCircle fontSize={12} fill="#FF0000"
            onClick={() => {
              dispatch(setAdditionalInfoPopover({ isOpen: true }))
            }} />
        )}
      </div>
      <div className="col center">
        {item.hasActiveAlarm && (
          <InfoTooltip tooltip="Alarm" element="span"
            classesProp="bg-item bg-transparent">
            <FaMusic fontSize={10} color="#606060" />
          </InfoTooltip>
        )}
      </div>
      <div className="col left">
        {item.incidents && item.incidents.length !== 0 && (
          <InfoTooltip tooltip="Opis incidenta" element="span"
            classesProp="bg-item bg-transparent">
            <TfiInfoAlt
              onClick={(e) => {
                dispatch(setIncidentPopover({
                  isOpen: true,
                  top: e.clientY + 7,
                  left: e.clientX + 2,
                }));
              }}
              fontSize={13} color="red" />
          </InfoTooltip>
        )}
      </div>

      <div className="col left">
        <input type="checkbox" />
      </div>
      <div className="col uppercase">
        <div className="bg-item">
          <span>{item.shortName}</span>
        </div>
      </div>
      <div className="col">
        {false && hasFullAccessTo(user, PARTNER_MODULE_NAME)
          ? (
            <span
              onClick={(e) => {
                dispatch(setIndexForDeletion(index));
                e.stopPropagation();
              }}
            >
              <CancelIcon style={{
                cursor: "pointer", fontSize: 15, color: grey[300]
              }} />
            </span>

          )
          : (<></>)}
      </div>
      <div className="col">
        <div className="bg-item center">
          <span className="strong">{item.id}</span>
        </div>
      </div>
      <div></div>
      <div className="col">
        <div className="bg-item bg-item-border-light center">
          <span className="light">
            {item.receivablesNextDueDate && FormatDate(item.receivablesNextDueDate)}
          </span>
        </div>
      </div>
      <div className="col">
        <div className="bg-item center">
          <span className="strong">
            {FormatMoneyNumber(item.receivablesTotalDebtAmount)}
          </span>
        </div>
      </div>
      <div className="col center">
        <input type="checkbox" />
      </div>
      <div className="col">
        <div className="bg-item center">
          <span className="strong">
            {FormatMoneyNumber(item.payablesTotalOutstandingAmount)}
          </span>
        </div>
      </div>
      <div className="col">
        <div className="bg-item bg-item-border-light center">
          <span className="light">
            {item.payablesNextDueDate && FormatDate(item.payablesNextDueDate)}
          </span>
        </div>
      </div>
      <div className="col center planOrXxx">
        {item.payablesTotalOutstandingXxxAmount !== 0 &&
          <div className="bg-item bg-item-border-light center">
            <span className="light">
              {FormatMoneyNumber(item.payablesTotalOutstandingXxxAmount)}
            </span>
          </div>
        }
      </div>
      <div className="col center planOrXxx">
        {item.receivablesPlanAmount !== 0 && (
          <div className="bg-item bg-item-border-dotted center">
            <span>{FormatMoneyNumber(item.receivablesPlanAmount)}</span>
          </div>
        )}
      </div>
      <div className="col center planOrXxx">
        {item.payablesPlanAmount !== 0 && (
          <div className="bg-item bg-item-border-dotted center">
            <span>{FormatMoneyNumber(item.payablesPlanAmount)}</span>
          </div>
        )}
      </div>

    </div>
  );
};

export default TableRow;
